import { post } from "@shared/utils/server";
import { useEffect, useMemo, useState } from "react";

interface IAcceptedBonus {
  balance: number;
  bonus: IBonus[];
  remaining_wager: number;
  wager: number;
}

interface IBonus {
  issuedAt: number;
  status: string;
  type: string;
  amount: number;
  wager: number;
  remainingWager: number | null;
}

const fetchAllBonuses = async (): Promise<IAcceptedBonus | null> => {
  const response = await post({
    method: "Bonus.getAccepted",
    args: {},
  });

  if (!Array.isArray(response)) {
    console.error("bonus must be an array");
    return null;
  }

  return response[0];
};

export const useAllBonuses = () => {
  const [bonuses, setBonuses] = useState<IBonus[] | null>(null);
  const [isPending, setIsPending] = useState(false);
  const [acceptedBonus, setAcceptedBonus] = useState<IAcceptedBonus | null>(
    null
  );

  const memoBonuses = useMemo(() => bonuses, [bonuses]);

  const fetchBonusInfo = async () => {
    try {
      setIsPending(true);
      const infoBonus = await fetchAllBonuses();
      const bonuses = infoBonus?.bonus;

      if (bonuses) {
        setAcceptedBonus(infoBonus);
        setBonuses(bonuses);
      }
    } catch (e: unknown) {
      console.error((e as Error).message);
    } finally {
      setIsPending(false);
    }
  };

  useEffect(() => {
    fetchBonusInfo();
  }, []);

  return { bonuses: memoBonuses, acceptedBonus, isPending };
};
